<template>
  <div>       
      <h1>Home</h1>
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
       
    }
  },
  mounted: function () {        
       this.$router.push({ path: 'view' })
  },
  methods: {
    
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// Home.vue?2b3df577